import { render, staticRenderFns } from "./FontSetting.vue?vue&type=template&id=4fb4fc68"
import script from "./FontSetting.vue?vue&type=script&lang=js"
export * from "./FontSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports